export { SortableModule } from './sortable.module';
export { SortableComponent } from './sortable.component';
export { DraggableItemService } from './draggable-item.service';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /app/SPA/~/ngx-bootstrap/sortable/index.js
// module id = ../../../../ngx-bootstrap/sortable/index.js
// module chunks = 4